export const FILE_MANAGER_API_PREFIX = 'filemanager/api';
const TEN_MEGABYTES_IN_BYTES = 10485760;
const ONE_HUNDRED_MIB_IN_BYTES = 100000000;
export const MAX_FILE_SIZE = TEN_MEGABYTES_IN_BYTES;
export const MAX_FILE_SIZE_PORTAL_53 = ONE_HUNDRED_MIB_IN_BYTES;
export const MAX_UPLOAD_PROGRESS_PERCENTAGE = 95;